// extracted by mini-css-extract-plugin
module.exports = {"localeContainer":"LocaleState_localeContainer__M6eVh"};